import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { CustomUrlMapperSiteConfig } from '../types'

const customUrlMapperSiteConfig: SiteConfigFn<CustomUrlMapperSiteConfig> = ({ api, funcLib }) => {
	const urlMappingsString = api.rendererModel.getUrlMappings()
	const shouldLoad = !!urlMappingsString

	const urlMappings = funcLib.parseJSON(urlMappingsString || 'null')
	const baseUrl = api.publicModel.getExternalBaseUrl()

	const siteConfig: CustomUrlMapperSiteConfig = {
		urlMappings,
		baseUrl,
	}

	return {
		shouldLoadSiteFeature: shouldLoad,
		shouldLoadSiteConfig: shouldLoad,
		siteConfig,
	}
}

const name = 'customUrlMapper'

export const config = { site: customUrlMapperSiteConfig, name }
